module.exports = __webpack_public_path__ + "static/img/19.cb65802.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/19.jpg
// module id = ifJt
// module chunks = 1